import { Record } from 'immutable';

const AGE_RANGE_TEXTS: { [key: string]: string } = {
  '20s': '20代',
  '30s': '30代',
  '40s': '40代',
  '50s_plus': '50代以上'
};

export type ApiReviewUser = {
  name: string;
  user_no: number;
}

const ReviewUserBase = Record({
  name: "",
  userNo: 0,
});

class ReviewUser extends ReviewUserBase {
  constructor(apiReviewUser?: ApiReviewUser) {
    super({
      name: apiReviewUser?.name,
      userNo: apiReviewUser?.user_no,
    })
  }
}

export type ApiDonorReview = {
  id: number;
  donor_id: number;
  donee_id: number;
  donor: ApiReviewUser;
  donee: ApiReviewUser;
  score: number;
  comment: string;
  age_range: string;
  created_at: string;
};

const DonorReviewBase = Record({
  id: 0,
  donorId: 0,
  donor: new ReviewUser(),
  doneeId: 0,
  donee: new ReviewUser(),
  score: 0,
  comment: "",
  ageRange: "",
  createdAt: ""
});

export class DonorReview extends DonorReviewBase {
  constructor(apiDonorReview?: ApiDonorReview) {
    super({
      id: apiDonorReview?.id,
      donorId: apiDonorReview?.donor_id,
      donor: new ReviewUser(apiDonorReview?.donor),
      doneeId: apiDonorReview?.donee_id,
      donee: new ReviewUser(apiDonorReview?.donee),
      score: apiDonorReview?.score,
      comment: apiDonorReview?.comment,
      ageRange: apiDonorReview?.age_range,
      createdAt: apiDonorReview?.created_at
    });
  }

  readonly ageRangeText: string = AGE_RANGE_TEXTS[this.ageRange];

  readonly stars: string = '★'.repeat(this.score) + '☆'.repeat(5 - this.score);
}
